import { useRouteError } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export default function ErrorPage() {
    const error = useRouteError();
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    };

    return (
        <div id="error-page">
            <h1>Oops!</h1>
            <p>Sorry, an unexpected error has occurred.</p>
            <p>
                <i>{error.statusText || error.message}</i>
            </p>
            <button onClick={goBack}>Go Back</button>
        </div>
    );
}
